import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaQuestionCircle, FaChevronDown, FaChevronUp } from "react-icons/fa";

const faqs = [
  {
    question: "What is Vicademics?",
    answer:
      "Vicademics is an innovative online platform where instructors can create and sell courses using videos, articles, and quizzes. Learners can purchase these courses and enjoy access for one year.",
  },
  {
    question: "How long can I access a course after purchase?",
    answer:
      "All purchased courses are valid for one year from the date of purchase. You can learn at your own pace during this period.",
  },
  {
    question: "What types of content can instructors add?",
    answer:
      "Instructors can add video lectures, detailed articles, and interactive quizzes to create a complete learning experience.",
  },
  {
    question: "Can I become an instructor on Vicademics?",
    answer:
      "Absolutely! Anyone with expertise in a subject can sign up as an instructor and start creating and sharing courses with the Vicademics community.",
  },
  {
    question: "Is there a refund policy?",
    answer:
      "We currently do not offer refunds. Please review the course content preview and details before purchasing.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center flex items-center justify-center p-6"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1584697964404-65987753a84d?auto=format&fit=crop&w=1470&q=80')",
      }}
    >
      <div className="bg-white bg-opacity-90 backdrop-blur-md rounded-3xl shadow-2xl max-w-3xl w-full p-8">
        <motion.h1
          className="text-4xl md:text-5xl font-bold text-center text-indigo-600 mb-6"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <FaQuestionCircle className="inline-block mr-2" />
          Frequently Asked Questions
        </motion.h1>

        {faqs.map((faq, index) => (
          <motion.div
            key={index}
            className="mb-4 border-b border-gray-300"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: index * 0.1 }}
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between items-center text-left py-4 text-lg font-medium text-gray-700 focus:outline-none"
            >
              {faq.question}
              {openIndex === index ? (
                <FaChevronUp className="text-indigo-500" />
              ) : (
                <FaChevronDown className="text-gray-500" />
              )}
            </button>

            <AnimatePresence>
              {openIndex === index && (
                <motion.p
                  className="text-gray-600 pb-4"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {faq.answer}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
